import React, { useState, useCallback, useEffect, useRef } from "react"
import {
  Menu,
  MenuItem,
  Button,
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Checkbox,
  FormControlLabel,
  Stack,
  LinearProgress,
  CircularProgress,
  IconButton,
  Modal,
} from "@mui/material"

import CloseIcon from "@mui/icons-material/CloseOutlined"
import { biteregModule } from "@/gluelayer/core/modules/bitereg/biteregModule"
import {
  EArchType,
  relabel,
  toothMovement,
  viewControlInTreatment,
  wasmModule,
  spaceCorrection,
  caseManagement,
  stageControl,
} from "@/gluelayer"

import { relabelModule } from "@/gluelayer/core/modules/relabel"
import { resegmentationModule } from "@/gluelayer/core/modules/resegmentation/resegmentationModule"
import { meshdeformModel } from "@/gluelayer/core/modules/modulemesh/modulemeshdeform"
import {
  setCurArch,
  setCurLeftPage,
  setIsOpenModelCheck,
  setOpenBiteReg,
  setOpenLiteMode,
  setOpenOrientation,
  setOpenRelabel,
  setOpenSpaceCorrection,
  setStageShowType,
  setZoomDisabled,
} from "../udTreatSlice"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { ReactSVG } from "react-svg"
import ModelCheck from "../assets/right/modelcheck.svg"
import { useTheme } from "@mui/material/styles"
import {
  setIsShowProgress,
  setProgressMsg,
} from "@/core/app/slices/clinical/clinicalSlice"
import { fetchZipsFromCacheOrRemote } from "@/core/app/slices/clinical/clinicalThunkApi"
import { useParams } from "react-router-dom"
import { resourcesSynchronization } from "@/gluelayer"
import { TipsPopover } from "../components/TipsPopover"
import { updateUserPreferences } from "@/core/app/slices/user/userApis"
import {
  fetchFilesList,
  downloadPhotoJSON,
} from "@/core/app/slices/records/photograph"
import { FileItem } from "@/core/app/slices/records/photograph/photograph.type"
import { get } from "@okta/okta-auth-js"
import {
  fetchPhotosInModelCheck,
  uploadModelCheckZips,
} from "../bottom/AutoModelCheck/modelCheckSlice"

import ResegmentTools from "../bottom/AutoModelCheck/ResegmentTools"
import RelabelTools from "../bottom/AutoModelCheck/RelabelTools"
import SpaceCorrectTools from "../bottom/AutoModelCheck/SpaceCorrectTools"
import RegistrationTools from "../bottom/AutoModelCheck/RegistrationTools"
import OrientationTools from "../bottom/AutoModelCheck/OrientationTools"
import ToothSurfaceTools from "../bottom/AutoModelCheck/ToothSurfaceTools"
import { bool } from "prop-types"

const UDModelCheck: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [selectedItem, setSelectedItem] = useState<string | null>(null)

  const [isPressed, setIsPressed] = useState(false) // 控制按钮背景色
  const open = !!anchorEl
  const dispatch = useAppDispatch()
  const {
    clinicalSettings: { NumberSystem },
  } = useAppSelector((state: RootState) => state.userService)
  const {
    curArch,
    openBiteReg,
    anyTpProtected,
    showJsPreview,
    curRightPage,
    singleArchBool,
    openHistorySplitView,
    startAutoModelCheck,
    curLeftPage,
    planList,
  } = useAppSelector((state: RootState) => state.udTreatService)
  const { openMode, isShowProgress, ProgressMsg } = useAppSelector(
    (state: RootState) => state.clinicalService,
  )
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { uassist_round } = caseDetail
  const [sameLabelDlg, setSameLabelDlg] = useState(false)
  const [deleteStageDlg, setDeleteStageDlg] = useState(false)
  const [tempSelectedItem, settempSelectedItem] = useState<string | null>(null)
  const { setstageShowTypeNormalCallback } = relabel
  const theme = useTheme()

  // for right toolbar tips popover
  const [popoverElement, setPopoverElement] = useState<HTMLElement | null>(null)
  const tipsAnchorEl = useRef<HTMLElement | null>(null)
  const { preferences } = useAppSelector(
    (state: RootState) => state.userService.user,
  )

  // console.log('????>>>>>!!!!!!222',openMode)

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      console.log("🚀 ~ isPressed:", isPressed)

      if (isPressed) {
        if (selectedItem !== "Check Segmentation")
          toothMovement.setIsEnableMoveTooth(true)
        if (relabelModule.IsRelabelModuleOpened()) {
          console.log("Relabel module is opened")
          if (
            relabelModule.IsExistSameLabelForSingleJaw(0) ||
            relabelModule.IsExistSameLabelForSingleJaw(1)
          ) {
            setSameLabelDlg(true)
            return
          }

          relabelModule.openRelabelModule(false)
          if (relabelModule.IsRelabelModuleOpened()) {
            dispatch(setIsShowProgress(true))

            // 这是做了更改后需要和服务器交互等待时间
            setstageShowTypeNormalCallback(() => {
              dispatch(setStageShowType("normal"))
              setIsPressed(false)
              setSelectedItem(null)
              dispatch(setIsOpenModelCheck(false))
              dispatch(setIsShowProgress(false))
              dispatch(setZoomDisabled(false))
            })
          } else {
            setIsPressed(false)
            setSelectedItem(null)
            dispatch(setIsOpenModelCheck(false))
            dispatch(setStageShowType("normal"))
            dispatch(setZoomDisabled(false))
          }
        } else {
          setIsPressed(false)
          setSelectedItem(null)
        }
      } else {
        setAnchorEl(event.currentTarget)
      }
    },
    [isPressed],
  )

  useEffect(() => {
    if (openMode !== "preview") {
      setPopoverElement(tipsAnchorEl.current)
    }
  }, [])

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleSelect = (item: string) => {
    //如果item是Labeling或者Bite Registration，弹出删除stage对话框
    if (item === "Check Label" || item === "Check Bite Registration") {
      setDeleteStageDlg(true)
      settempSelectedItem(item)
      return
    }
    // Check Orientation 设置为双颌模式，否则split 会导致出错
    if (item === "Check Orientation") {
      viewControlInTreatment.showArchMode("all")
    }
    setSelectedItem(item)
    setIsPressed(true)
    handleClose()
    dispatch(setIsOpenModelCheck(true))
  }

  const [isShowPopover, setIsShowPopover] = useState(true)

  const [title, setTitle] = useState("")

  const { caseId, patientId } = useParams()

  const onClickResegAddATooth = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.AddATooth()
  }

  const onClickResegRemoveATooth = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.RemoveATooth()
  }

  const onClickResegPaint = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.StartPaint()
  }

  const onClickResegDragEdge = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.StartDragEdge()
  }

  const onClickResegUndo = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.Undo()
  }

  const onClickResegReset = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    //resegmentationModule.Undo()
  }

  const onClickResegIdel = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.CancelOperation()
  }

  const onClickResegClose = (e) => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    if (resegmentationModule.DoNeedRelabel()) {
      if (isPressed) {
        setIsPressed(false)
      }
    } else {
      handleClick(e)
    }
  }

  const onClickRelabelClose = (e) => {
    if (resegmentationModule.isResegmentationModuleOpened()) {
      if (resegmentationModule.isRelabelModuleOpened()) {
        dispatch(setProgressMsg("post process ..."))
        dispatch(setIsShowProgress(true))
        resegmentationModule.CloseRelabel().then(() => {
          onResegmentationRelabelFinishCallback()
        })
      }
    } else {
      if (relabelModule.IsRelabelModuleOpened()) {
        handleClick(e)
      }
    }
  }

  const onClickRelabelReset = (e) => {
    if (
      resegmentationModule.isResegmentationModuleOpened() &&
      resegmentationModule.isRelabelModuleOpened()
    ) {
      resegmentationModule.ResetRelabel()
    } else {
      if (relabelModule.IsRelabelModuleOpened()) {
        relabelModule.Reset()
      }
    }
  }

  const onClickOriatationSave = () => {
    const oriModule = wasmModule.moduleManager.GetModuleOrientationAdjustment()
    if (oriModule) {
      oriModule.SaveOrientation()
    }
  }

  const onClickToothSurfacePaint = (On: boolean) => {
    if (On) {
      meshdeformModel.StartSelectCells()
    } else {
      meshdeformModel.CloseSelectCells()
    }
  }

  const onClickToothSurfaceInOut = (On: boolean) => {
    meshdeformModel.StartDeform(On)
  }
  const onClickToothSurfaceSmooth = (On: boolean) => {
    meshdeformModel.StartSmoothMesh(0.8, On)
  }
  const onClickToothSurfaceCutFill = (On: boolean) => {
    meshdeformModel.FillTooth()
  }
  const onClickToothSurfaceUndo = () => {
    meshdeformModel.BackOneStep()
  }
  const onClickToothSurfaceReset = () => {
    meshdeformModel.Reset()
  }

  const onClickBiteUndo = () => {
    const biteModule = wasmModule.moduleManager.GetModuleBiteReg()
    if (biteModule) {
      biteModule.Undo()
    }
  }

  const onClickBiteReset = () => {
    const biteModule = wasmModule.moduleManager.GetModuleBiteReg()
    if (biteModule) {
      biteModule.Reset()
    }
  }

  const onResegmentationRelabelFinishCallback = () => {
    setResegRelabelShow(false)
    dispatch(setIsOpenModelCheck(false))
    dispatch(setStageShowType("normal"))
    dispatch(setCurArch("all"))
    viewControlInTreatment.setViewType("front")
    setTitle("")
    dispatch(setIsShowProgress(false))
    dispatch(setZoomDisabled(false))

    setIsPressed(false)
    setSelectedItem(null)

    // 在这里删方案是为了保证resegmentation和relabel都关闭后再删方案，避免牙合出现重叠异常
    if (planList.length > 1) caseManagement.delTx(2)
    caseManagement.delTx(1)
    dispatch(uploadModelCheckZips({ patientId, caseId }))
  }

  const [resegRelabelShow, setResegRelabelShow] = useState(false)
  useEffect(() => {
    if (resegRelabelShow) {
      if (resegmentationModule.IsInResegRelabel() == false) {
        resegmentationModule.GotoRelabel()
      }
    }
  }, [resegRelabelShow])

  //缓存上一个curArch状态
  const prevCurArchRef = useRef<string>(curArch)
  useEffect(() => {
    // 在"Spacing"中，如果当前是"all"模式，则还是保持原来的上下颌模式
    if (
      (selectedItem === "Check Space" ||
        selectedItem === "Check Label" ||
        selectedItem === "Check Segmentation") &&
      curArch === "all"
    ) {
      dispatch(setCurArch(prevCurArchRef.current))
    }
    prevCurArchRef.current = curArch
  }, [curArch])

  const checkDownloadSettingData0 = async (): Promise<boolean> => {
    const files: Record<string, Record<string, File>> = {}
    files["Setting Data0"] =
      await resourcesSynchronization.getFileListFromVirtualFS("Setting Data0")
    const zipKeys = Object.keys(files["Setting Data0"])
    if (zipKeys.length === 0) {
      try {
        const bulk0Zip: Record<string, any> = {}
        async function retryRequest(retriesLeft, delay) {
          const ret: any = await dispatch(
            fetchZipsFromCacheOrRemote({
              caseId,
              patientId,
              zipNames: ["bulk0"],
              isDownloadRetouchHistory: false,
            }),
          ).unwrap()

          const keys = Object.keys(ret)
          let findBulk0 = false
          for (const key of keys) {
            if (key === "bulk0.zip") {
              bulk0Zip[key] = ret[key]
              findBulk0 = true
              break
            }
          }

          if (!findBulk0) {
            if (retriesLeft > 0) {
              console.error("Retrying to download sd10...", retriesLeft)

              await new Promise((resolve) => setTimeout(resolve, delay))
              return retryRequest(retriesLeft - 1, delay)
            } else {
              console.log("Not downloaded to bulk0.zip")
              return findBulk0
            }
          }
          return findBulk0
        }

        const findBulk0 = await retryRequest(3, 1000)
        if (findBulk0) {
          await resourcesSynchronization.writeCaseFilesToVirtualFS(bulk0Zip)
          files["Setting Data0"] =
            await resourcesSynchronization.getFileListFromVirtualFS(
              "Setting Data0",
            )
          const zipKeys = Object.keys(files["Setting Data0"])
          if (zipKeys.length === 0) {
            console.log(
              "Segmentation: After downloading and unzipping, there are no files in Setting Data0",
            )
            return false
          }
          wasmModule.statusController.InitSettingData0FoldersSHA()
        } else {
          return false
        }
      } catch (error) {
        console.log("Segmentation error : ", error)
        return false
      }
    }

    return true
  }

  const spaceApplyStatusCallback = (isPending: number) => {
    if (isPending === 1) {
      dispatch(setProgressMsg("Space Progressing"))
      dispatch(setIsShowProgress(true))
      setTimeout(() => {
        spaceCorrection.pendingApplyEditValue()
      }, 50)
    } else {
      dispatch(setIsShowProgress(false))
    }
  }

  useEffect(() => {
    console.log("selectedItem: ", selectedItem)
    if (!selectedItem || !wasmModule.isFinishedOpencase) return

    toothMovement.setIsEnableMoveTooth(false)

    setTitle(selectedItem)
    dispatch(setStageShowType(""))
    switch (selectedItem) {
      case "Check Segmentation":
        console.log("Check Segmentation")
        const seg = async () => {
          const downloadData0Res: boolean = await checkDownloadSettingData0()
          if (!downloadData0Res) return

          await stageControl.setStageStep(0, 0)
          const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
          await dispatch(setCurArch(hasUpper ? "up" : "low"))
          viewControlInTreatment.showArchMode(hasUpper ? "up" : "low")
          resegmentationModule.numberSystem = NumberSystem
          await resegmentationModule.openResegmentationModule(true)
        }

        setResegRelabelShow(false)
        seg()

        break
      case "Check Label":
        dispatch(setZoomDisabled(true))
        if (
          relabelModule.IsExistSameLabelForSingleJaw(0) ||
          relabelModule.IsExistSameLabelForSingleJaw(1)
        ) {
          console.log("Same label exists")
          return
        }
        const relabel = async () => {
          //viewControlInTreatment.zoomWithValueInTreatment(1)
          //if (wasmModule.moduleManager.GetSplitScreenModule() === null) {
          //if (curArch === "all") await dispatch(setCurArch("up"))
          //}
          const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
          const hasLower = wasmModule.getArchModel(EArchType.LowArch)
          if (hasUpper && hasLower) {
            viewControlInTreatment.showArchMode("all")
            wasmModule.statusController.SplitScreenDisplay(false)
            viewControlInTreatment.showArchMode("up")
            await dispatch(setCurArch("up"))
          } else {
            await dispatch(setCurArch(hasUpper ? "up" : "low"))
          }
          //if (curArch === "all") await dispatch(setCurArch("up"))
          relabelModule.numberSystem = NumberSystem
          relabelModule.openRelabelModule(true)
          if ((window as any).pulloutCallback()) {
            ;(window as any).pulloutCallback()
          }
          // await dispatch(setStageShowType(""))
          if (relabelModule.IsRelabelModuleOpened()) {
            await dispatch(setOpenRelabel(true))
            if ((window as any).treatment.RelabelViewZoomCallback) {
              ;(window as any).treatment.RelabelViewZoomCallback(
                relabelModule.zoomValue,
              )
            }
          }
        }

        relabel()
        break
      case "Check Bite Registration":
        const biteReg: () => Promise<void> = async () => {
          const downloadData0Res: boolean = await checkDownloadSettingData0()
          if (!downloadData0Res) return
          dispatch(setOpenBiteReg(true))
          dispatch(
            fetchPhotosInModelCheck({
              patientId,
              caseId,
              refinementIndex: uassist_round,
            }),
          )
        }
        biteReg()
        break
      case "Check Space":
        dispatch(setStageShowType(""))
        const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
        dispatch(setCurArch(hasUpper ? "up" : "low"))
        spaceCorrection.openSpaceCorrectionModule(true)
        spaceCorrection.setApplyStatusCallback(spaceApplyStatusCallback)
        dispatch(setOpenSpaceCorrection(true))
        break
      case "Check Orientation":
        dispatch(setZoomDisabled(true))
        dispatch(setOpenOrientation(true))
        dispatch(setCurArch("all"))
        viewControlInTreatment.setViewType("front")
        wasmModule.moduleManager.SwitchModuleOrientationAdjustment(true)
        if (singleArchBool) {
          const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
          dispatch(setCurArch(hasUpper ? "up" : "low"))
        }
        dispatch(
          fetchPhotosInModelCheck({
            patientId,
            caseId,
            refinementIndex: uassist_round,
          }),
        )
        break
      case "Check Model Surface":
        //if (singleArchBool)
        {
          stageControl.setStageStep(0, 0)

          const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
          dispatch(setCurArch(hasUpper ? "up" : "low"))
          viewControlInTreatment.setAttachmentVisibility(true)
          viewControlInTreatment.specialToothColorToggle(true)
          meshdeformModel.SwitchMeshDeformModule(true)
        }
        break
      default:
        console.warn("Unknown menu item selected:", selectedItem)
    }
    viewControlInTreatment.hoverToothToggle(false)
  }, [selectedItem])

  useEffect(() => {
    if (selectedItem !== "Check Orientation") return
    const oriModule = wasmModule.moduleManager.GetModuleOrientationAdjustment()
    oriModule.ShowPhotoPanel(curLeftPage === "records")
  }, [curLeftPage, selectedItem])

  useEffect(() => {
    if (isPressed || !wasmModule.isFinishedOpencase) return

    console.log("Model Check button is closed")

    const closeModule = async () => {
      if (wasmModule.moduleManager.GetModuleOrientationAdjustment() !== null) {
        console.log("SwitchModuleOrientationAdjustment(false)")
        wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
        dispatch(setCurLeftPage(""))
      }
      if (wasmModule.moduleManager.GetSpaceCorrectionModule() !== null) {
        console.log("ToggleSpaceCorrect(false)")
        spaceCorrection.openSpaceCorrectionModule(false)
        dispatch(setOpenSpaceCorrection(false))
      }
      if (resegmentationModule.isResegmentationModuleOpened()) {
        console.log("resegmentationModule.openResegmentationModule(false)")
        if (resegmentationModule.DoNeedRelabel()) {
          setResegRelabelShow(true)
        } else {
          dispatch(setProgressMsg("Post Processing..."))
          dispatch(setIsShowProgress(true))
          await resegmentationModule.openResegmentationModule(false)
          dispatch(setIsShowProgress(false))
         
          const data = stageControl.getWasmStageData()
          stageControl.setStageStep(
            data.jointUpKeypoints.length,
            data.jointLowerKeypoints.length,
          )
        }
      }
      if (openBiteReg) {
        dispatch(setProgressMsg("Post Processing..."))
        dispatch(setIsShowProgress(true))
        await biteregModule.SaveData()
        dispatch(setOpenBiteReg(false))
        dispatch(setCurLeftPage(""))
        wasmModule.moduleManager.SwitchModuleBiteReg(false)
        dispatch(setIsShowProgress(false))
      }

      if (wasmModule.moduleManager.GetMeshDeformModule() !== null) {
        meshdeformModel.SwitchMeshDeformModule(false)

        const data = stageControl.getWasmStageData()
        stageControl.setStageStep(
          data.jointUpKeypoints.length,
          data.jointLowerKeypoints.length,
        )
      }

      if (!resegmentationModule.isResegmentationModuleOpened()) {
        dispatch(setIsOpenModelCheck(false))
        dispatch(setStageShowType("normal"))
        dispatch(setCurArch("all"))
        viewControlInTreatment.setViewType("front")
        setTitle("")
        dispatch(setZoomDisabled(false))
        dispatch(uploadModelCheckZips({ patientId, caseId }))
      }
    }

    closeModule()
  }, [isPressed])

  const menuItems = [
    "Check Segmentation",
    "Check Label",
    "Check Bite Registration",
    "Check Space",
    "Check Orientation",
    "Check Model Surface",
  ]

  return (
    <>
      <Box
        visibility={
          !anyTpProtected &&
          openMode !== "preview" &&
          !showJsPreview &&
          !openHistorySplitView &&
          !startAutoModelCheck
            ? "visible"
            : "hidden"
        }
        ref={tipsAnchorEl}
        sx={{
          position: "absolute",
          right: 16,
          top: 293,
        }}
      >
        <Tooltip title="Model Check" placement="left">
          {selectedItem === null && (
            <Button
              disabled={curRightPage ? true : false}
              sx={{
                minWidth: 0, // 解决 MUI 默认最小宽度 64px 的问题
                padding: 0, // 取消默认的内边距，确保大小准确
                backgroundColor: theme.transBkColor.light,
                textTransform: "none",
                width: "48px",
                height: "48px",
                flexWrap: "wrap",
                border: "none",
                borderRadius: "8px",
                boxShadow: "0 6px 10px 0px rgba(0, 0, 0, 0.15)",
                "&:hover": {
                  backgroundColor: theme.transBkColor.light,
                  opacity: 0.65,
                },
                "&.Mui-selected": {
                  backgroundColor: theme.transBkColor.light,
                  opacity: 0.65,
                },
                ":disabled": {
                  backgroundColor: theme.transBkColor.light,
                  opacity: 0.65,
                },
              }}
              onClick={handleClick}
            >
              <ReactSVG
                src={ModelCheck}
                afterInjection={(svg) => {
                  const path = svg.getElementsByTagName("path")[0]
                  if (isPressed) {
                    path?.setAttribute("fill", "#215ECD")
                    path?.setAttribute("fill-opacity", "1")
                  }
                }}
                style={{ marginTop: 6 }}
              ></ReactSVG>
            </Button>
          )}
        </Tooltip>

        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: -10 }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              disabled={index == 2 && singleArchBool}
              onClick={() => handleSelect(item)}
            >
              {item}
            </MenuItem>
          ))}
        </Menu>
      </Box>

      {selectedItem === "Check Segmentation" && !resegRelabelShow && (
        <ResegmentTools
          DoShowClose={true}
          ClickAddTooth={onClickResegAddATooth}
          ClickDelTooth={onClickResegRemoveATooth}
          ClickPaint={onClickResegPaint}
          ClickDrag={onClickResegDragEdge}
          ClickUndo={onClickResegUndo}
          ClickReset={onClickResegReset}
          ClickIdel={onClickResegIdel}
          ClickClose={onClickResegClose}
        />
      )}
      {((selectedItem === "Check Segmentation" && resegRelabelShow) ||
        selectedItem === "Check Label") && (
        <RelabelTools
          DoShowClose={true}
          ClickReset={onClickRelabelReset}
          ClickClose={onClickRelabelClose}
        />
      )}
      {selectedItem === "Check Space" && (
        <SpaceCorrectTools DoShowClose={true} ClickClose={handleClick} />
      )}
      {selectedItem === "Check Bite Registration" && (
        <RegistrationTools
          DoShowClose={true}
          ClickClose={handleClick}
          ClickUndo={onClickBiteUndo}
          ClickReset={onClickBiteReset}
        />
      )}
      {selectedItem === "Check Orientation" && (
        <OrientationTools
          DoShowClose={true}
          ClickSave={onClickOriatationSave}
          ClickClose={handleClick}
        />
      )}
      {selectedItem === "Check Model Surface" && (
        <ToothSurfaceTools
          DoShowClose={true}
          ClickPaint={onClickToothSurfacePaint}
          ClickInOut={onClickToothSurfaceInOut}
          ClickSmooth={onClickToothSurfaceSmooth}
          ClickCutFill={onClickToothSurfaceCutFill}
          ClickUndo={onClickToothSurfaceUndo}
          ClickReset={onClickToothSurfaceReset}
          ClickClose={handleClick}
        />
      )}

      {!preferences?.do_not_show_modelcheck_popover && popoverElement && (
        <Modal
          open={isShowPopover}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <TipsPopover open={isShowPopover} anchorEl={popoverElement}>
              <Box
                sx={{
                  width: "100%",
                  position: "absolute",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton
                  sx={{ color: "#FFF" }}
                  onClick={() => setIsShowPopover(false)}
                >
                  <CloseIcon />
                </IconButton>
                {/* <Button sx={{position:'relative',right:'10px',color:'#FFF'}} variant="text">X</Button> */}
              </Box>
              <Typography sx={{ marginTop: "18px", p: 2 }} variant="body2">
                You may review all these steps at any time here.
              </Typography>
              <FormControlLabel
                sx={{
                  marginLeft: "0px",
                  marginBottom: "10px",
                  paddingLeft: "20px",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "12px",
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: "24px",
                  },
                }}
                control={
                  <Checkbox
                    sx={{ color: "#fff" }}
                    onChange={({ target: { checked } }) => {
                      if (checked) {
                        dispatch(
                          updateUserPreferences({
                            do_not_show_modelcheck_popover: true,
                          }),
                        )
                      } else {
                        dispatch(
                          updateUserPreferences({
                            do_not_show_modelcheck_popover: false,
                          }),
                        )
                      }
                    }}
                  />
                }
                label="Do not show this again"
              />
            </TipsPopover>
          </div>
        </Modal>
      )}

      <Dialog open={sameLabelDlg}>
        <DialogTitle id="alert-dialog-title">{"uDesign Cloud"}</DialogTitle>
        <DialogContent>{"There are duplicates, please relabel!"}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => setSameLabelDlg(false)}
            autoFocus
            sx={{ textTransform: "samelabel" }}
            size="medium"
            color="primary"
            variant="contained"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteStageDlg}>
        <DialogTitle id="alert-dialog-title">{"uDesign Cloud"}</DialogTitle>
        <DialogContent>{`Changing the tooth ${tempSelectedItem?.toLowerCase()} will delete the treatment plan.
Do you want to proceed?`}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (tempSelectedItem === "Check Bite Registration") {
                dispatch(setCurArch("all"))
              }
              setDeleteStageDlg(false) // 关闭对话框
              handleClose()
              setTimeout(() => {
                if (planList.length > 1) caseManagement.delTx(2)
                caseManagement.delTx(1)
                setSelectedItem(tempSelectedItem)
                settempSelectedItem(null) // 清除临时变量
                setIsPressed(true)

                dispatch(setIsOpenModelCheck(true))
              }, 10)
            }}
            autoFocus
            sx={{ textTransform: "samelabel" }}
            size="medium"
            color="primary"
            variant="contained"
          >
            Yes
          </Button>
          <Button
            onClick={() => setDeleteStageDlg(false)}
            autoFocus
            sx={{ textTransform: "samelabel" }}
            size="medium"
            color="primary"
            variant="contained"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default UDModelCheck
